import { ClientPortalTranslate } from './clientPortalTranslate.model';

const clientPortalTranslateEN: ClientPortalTranslate = {
  loading: 'Opening your portal…',
  greeting: 'Hi, {{name}}',
  subtitle: 'Everything about your work with {{studioName}} in one place.',
  gate: {
    title: 'Confirm your ID number',
    description:
      'To protect your data, enter the ID number registered with the studio.',
    documentLabel: 'ID number',
    submit: 'Open my portal',
    error:
      'We could not open the portal. Check the link and the ID number and try again.',
    privacyNotice:
      'We only use your ID number to confirm this link belongs to you.',
    validation: {
      documentRequired: 'Enter your ID number',
      documentInvalid: 'Enter a valid ID number',
    },
  },
  sections: {
    events: {
      title: 'Your events',
      empty: 'No events scheduled yet.',
      dateLabel: 'Date',
      locationLabel: 'Location',
      noDate: 'To be defined',
      noLocation: 'To be defined',
    },
    contracts: {
      title: 'Contracts',
      empty: 'No contracts available yet.',
      issuedAt: 'Issued on {{date}}',
      signedAt: 'Signed on {{date}}',
      sign: 'Sign contract',
      expiresAt: 'Link valid until {{date}}',
      status: {
        ISSUED: 'Awaiting signature',
        SIGNED: 'Signed',
      },
    },
    sales: {
      title: 'Payments',
      empty: 'No payments registered yet.',
      total: 'Total {{value}}',
      installmentsCount: '{{count}}x',
      installmentLabel: 'Installment {{number}}',
      dueDate: 'Due on {{date}}',
      paidAt: 'Paid on {{date}}',
      status: {
        PENDING: 'Upcoming',
        PAID: 'Paid',
        OVERDUE: 'Overdue',
      },
    },
    galleries: {
      title: 'Galleries',
      empty: 'No published galleries yet.',
      photos: '{{count}} photos',
      open: 'Open gallery',
      selectionLimit: 'You can pick up to {{count}} photos',
      selectionConfirmed: 'Selection confirmed on {{date}}',
    },
  },
  manage: {
    title: 'Client portal',
    description:
      'Generate a single link so your client can follow contracts, payments, events and galleries.',
    generate: 'Generate portal link',
    revoke: 'Revoke link',
    copy: 'Copy link',
    tip: 'The client must confirm the registered ID number to open the portal.',
    missingDocument:
      'Fill in the client ID number under the Contracts tab to enable the portal.',
    toast: {
      generated: 'Portal link generated',
      revoked: 'Portal link revoked',
      linkCopied: 'Link copied',
      linkCopyError: 'Could not copy the link',
      error: 'Could not complete the action. Please try again.',
    },
    revokeConfirm: {
      title: 'Revoke the portal link?',
      text: 'The current link stops working immediately.',
      secondaryText: 'You can generate a new link later if you need to.',
      confirm: 'Revoke',
      cancel: 'Cancel',
    },
  },
};

export default clientPortalTranslateEN;
